<template>
  <!-- 病因分析 -->
  <div class="etiologicalAnalysisWorkFlow full-screen">
    <div class="ucard">
      <div class="ucard_body">
        <div class="full_btn" @click="close">
          <Icon type="md-close" />
        </div>
        <div class="markdown-body" v-html="renderMarkdownIn(content)"></div>
      </div>
    </div>
    <Spin class="u_spin" v-if="!isAiReturnPrescription" fix>
      <Icon type="ios-loading" size="30" class="demo-spin-icon-load"></Icon>
      <div>加载中...</div>
    </Spin>
  </div>
</template>

<script>
import request from "@/utils/request.js";
import { mapGetters } from "vuex";
import { renderMarkdown } from '@/utils/markdown';
export default {
  props: {
    info: {
      type: Object,
      default: function () {
        return {};
      },
    },
    recall: {
      type: Function,
      default: () => { },
    },
  },
  watch: {
    info() {
      this.init();
    },
    isAiReturnPrescription() {
      this.init();
    }
  },
  data() {
    return {
      content: "",
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["indexSpin", "userInfo", "isAiReturnPrescription"]),
  },
  methods: {
    renderMarkdownIn() {
      return renderMarkdown(this.content);
    },
    close() {
      this.$emit("close");
    },

    setData() {
      request.post("mra/getMraWorkflowAnalysisById", {
        patientCode: this.info.patientCode,
      }).then((res) => {
        this.content = res.result.analysis;
      });
    },

    init() {
      if (this.isAiReturnPrescription) {
        this.setData();
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.etiologicalAnalysisWorkFlow {
  background: #fff;
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  padding: 0 15px 15px;
  width: 100%;
  height: 100%;

  &.full-screen {
    position: fixed;
    padding: 0;
    z-index: 1000;
  }

  .full_btn {
    position: fixed;
    padding: 2px 10px;
    right: 10px;
    top: 10px;
    cursor: pointer;
    z-index: 101;
    font-weight: bold;
    font-size: 20px;
    :hover {
      opacity: 0.8;
    }
  }

  .markdown-body {
    padding: 20px;
    line-height: 2em;

    :deep {

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-weight: bold;
        margin-top: 0.5em;
        margin-bottom: 0.5em;
      }

      h1 {
        font-size: 24px;
        border-bottom: 2px solid #ccc;
        padding-bottom: 8px;
      }

      h2 {
        font-size: 20px;
        border-bottom: 1px solid #eee;
        padding-bottom: 6px;
      }

      h3 {
        font-size: 18px;
      }

      p {
        margin: 1em 0;
        line-height: 1.8;
      }

      ul,
      ol {
        margin: 1em 0;
        padding-left: 2em;

        li {
          margin: 0.5em 0;
          line-height: 1.8;
        }
      }

      blockquote {
        border-left: 4px solid #ccc;
        padding: 10px 15px;
        margin: 1em 0;
        background: #f5f5f5;
      }

      code {
        background: #f5f5f5;
        padding: 2px 6px;
        border-radius: 4px;
        font-family: "Courier New", monospace;
        font-size: 0.9em;
      }

      pre {
        background: #f5f5f5;
        padding: 15px;
        border-radius: 8px;
        overflow-x: auto;
        margin: 1em 0;

        code {
          background: none;
          padding: 0;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;
        margin: 1em 0;

        th,
        td {
          border: 1px solid #ccc;
          padding: 8px 12px;
          text-align: left;
        }

        th {
          background: #f5f5f5;
          font-weight: bold;
        }
      }

      img {
        max-width: 100%;
        border-radius: 4px;
      }

      hr {
        border: none;
        border-top: 1px solid #eee;
        margin: 2em 0;
      }
    }
  }
}
</style>
